
<template>
  <div>
    <dialog-loading v-if="loading.saving" loadingText='Salvando...'></dialog-loading>
    <v-dialog persistent v-model="dialog" max-width="700px">
      <v-form ref="form">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-wallet-plus</v-icon>
            Adicionar forma padrão de pagamento
          </v-card-title>
          <v-card-text>
            <v-card style="border-radius:12px" outlined>
              <v-card-title primary-title class="py-2 grey lighten-2">
                <div class="headline mb-0">Pagamento:</div>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text class="pa-5 pt-2">
                  <v-autocomplete
                    v-model="default_client_payment.payment_option_id"
                    :items="payment_options"
                    label="Modo de pagamento"
                    hide-no-data
                    item-text="attributes.description"
                    item-value="id"
                    prepend-icon="mdi-information"
                    :loading="loading.payment_options"
                    :rules="required"
                  >
                    <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                  </v-autocomplete>
                  <v-autocomplete
                    v-model="default_client_payment.payment_time_id"
                    :items="payment_times"
                    label="Prazo para pagamento"
                    hide-no-data
                    item-text="attributes.description"
                    item-value="id"
                    prepend-icon="mdi-calendar"
                    :loading="loading.payment_times"
                    :rules="required"
                  >
                    <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                  </v-autocomplete>
                  <v-text-field 
                    type="number"
                    label="Porcentagem" 
                    prepend-icon="mdi-percent" 
                    v-model="default_client_payment.percentage" 
                    :rules="notZeroPercentage2"
                  ></v-text-field>
                  <v-alert 
                    v-if="total_sum > 100"
                    type="error"
                  >A soma das porcentagens é  {{total_sum}}% ( Máximo 100% )</v-alert>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <f-btn cancel @click="closeDialog"></f-btn>
            <f-btn save @click="submitDefaultClientPayment" :disabled="total_sum > 100"></f-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import validations from "@/mixins/validations.js"
import Api from '@/api/index';

export default {
  name: 'DialogAddDefaultClientPayment',
  mixins: [ validations ],
  props:{
    dialog:{
      type: Boolean,
      default: false,
    },
    default_client_payment_edit: {
      type: Object,
      default: null
    },
    client_payments:{
      type: Array,
      default: []
    }
  },
  data() {
    return {
      default_client_payment: {
        payment_option_id: null,
        payment_time_id: null,
        client_id: null,
        percentage: 0,
      },
      payment_options: [],
      payment_times: [],
      loading:{
        saving:false,
        payment_options: false,
        payment_times: false,
      },
    }
  },
  methods: {
    getData() {
      this.getPaymentOptions()
      this.getPaymentTimes()
      if(this.default_client_payment_edit){
        let { payment_option_id, payment_time_id, client_id, percentage, id } = JSON.parse(JSON.stringify(this.default_client_payment_edit))
        this.default_client_payment = { 
          payment_option_id: payment_option_id.toString(),
          payment_time_id: payment_time_id.toString(),
          client_id: client_id.toString(),
          percentage: percentage.toString(),
          id: id
        }
      }
    },
    closeDialog(){
      this.resetData()
      this.$emit('closeDialog')
    },
    resetData(){
      this.default_client_payment = {
        payment_option_id: null,
        payment_time_id: null,
        client_id: null,
        percentage: 0,
      }
    },
    submitDefaultClientPayment(){
      if(this.$refs.form.validate()){
        this.loading.saving = true
        this.default_client_payment.client_id = this.$route.params.id
        let METHOD = 'create'
        if(this.default_client_payment.id){
          METHOD = 'update'
        }
        Api.DefaultClientPayment[`${METHOD}`](this.default_client_payment).then(()=>{
          this.successSaved()
          this.$emit('updated')
          this.closeDialog()
        }).finally(()=>{
          this.loading.saving = false
        })
      }
    },
    getPaymentTimes(){
      this.loading.payment_times = true
      Api.PaymentOption.index("times").then(res => {
        this.payment_times = [...res.data.data]
      }).finally(()=>{
        this.loading.payment_times = false
      })  
    },
    getPaymentOptions(){
      this.loading.payment_options = true
      Api.PaymentOption.index("options").then(res => {
        this.payment_options = [...res.data.data]
      }).finally(()=>{
        this.loading.payment_options = false
        
      })

    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    total_sum() {
      let item_id = this.default_client_payment?.id
      return this.client_payments.filter(el=> el.id != item_id).reduce((acc, el) => el.percentage + acc, parseInt(this.default_client_payment.percentage))
    }
  },
}
</script>